import React from "react";
import { useNavigate } from "react-router-dom";
import useChangeTitle from "../../custom-hooks/UseChangeTitle";

const Error404 = ({ tabTitle }) => {
  useChangeTitle(tabTitle);

  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <div className="flex items-center justify-center w-full h-[calc(100vh-6.75rem)] bg-[#dadaf3]">
      <div className="px-40 py-20 bg-white rounded-md shadow-xl">
        <div className="flex flex-col items-center">
          <h1 className="font-bold text-[#5C5CC0] text-9xl">404</h1>

          <h6 className="mb-2 text-2xl font-bold text-center text-gray-800 md:text-3xl">
            <span className="text-red-500">Oops!</span> Page not found
          </h6>

          <p className="mb-8 text-center text-gray-500 md:text-lg">
            The page you’re looking for doesn’t exist.
          </p>

          <button
            type="button"
            className="text-white bg-[#5555b6] hover:bg-[#3b3b8f] focus:ring-4 focus:ring-[#9393eb] font-medium rounded-full text-sm px-5 py-2.5 text-center mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-[#5C5CC0] dark:focus:ring-[#5C5CC0]"
            onClick={goBack}
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default Error404;
